/* eslint-disable */
export const yellowCardIcon = {
  data: `<svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.744568" y="0.0429688" width="8.26389" height="11.8793" rx="1.03299" fill="#FFDC00"/>
</svg>
`,
  name: 'yellow-card' as const,
};
